import React from "react";
import DomainManagement from "../../Containers/DomainManagementContainer";

const DomainManagementContainer = (props) => {
	return (
		<DomainManagement />
	);
}

export default DomainManagementContainer;